<template>
    <!--<vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip-->

    <vs-progress :percent="Number(params.value)/Number(this.$store.state.stockList.popularity)*100" :color="getPopularityColor(Number(params.value)/Number(this.$store.state.stockList.popularity)*100)" class="shadow-md" />
    
</template>

<script>
export default { 
  name: 'CellRendererPopularity',
  computed: {
    getPopularityColor () {
      return (value) => {
        if (value >= 50) return 'success'
        else if (value < 50 && value >= 10) return 'warning'
        else if (value < 10) return 'danger'
        else return 'white'
      }
    }
  }
}
</script>
